import { createContext } from 'react';

import { IAnalyticsContext } from './types';

export const NO_OP_ANALYTICS_CONTEXT_VALUE: IAnalyticsContext = {
  addPersistentParams: () => {},
  captureAnalyticsTagEvent: () => {},
  captureEvent: () => {},
  captureEventWithActiveScreen: () => {},
  captureEventWithTopicSource: () => {},
  captureEventWithTopicSourceAndActiveScreen: () => {},
};

const AnalyticsContext = createContext<IAnalyticsContext>(NO_OP_ANALYTICS_CONTEXT_VALUE);

export default AnalyticsContext;
